import { isEnvFlagEnabled } from "@/shared/envFlags.ts";

/**
 * Whether this build carries the React Query devtools.
 *
 * Set `VITE_SHOW_REACT_QUERY_DEVTOOLS=true` (or `1`) in `web/.env.local` to
 * get the header toggle and the panel it opens.
 *
 * The `import.meta.env.DEV` guard leads, and both halves are reached by dot
 * access, so Vite folds the whole expression to `false` in a production build
 * and the toggle, the panel and tanstack's devtools module are all dropped.
 * Read out of a bracket it would stay a runtime lookup, and the devtools would
 * ship to users on the strength of a build variable — which is what the
 * deployed bundle sets it to.
 */
export const SHOW_QUERY_DEVTOOLS =
  import.meta.env.DEV && isEnvFlagEnabled(import.meta.env.VITE_SHOW_REACT_QUERY_DEVTOOLS);
